import { ReactNode } from "react";
import { Linking, Platform } from "react-native";
import ErrIcon from "@/assets/icons/main/redAlert.svg";
import { toast } from "sonner-native";

export interface IHandleDownloadOptions {
  url: string | undefined;
  errorMessage?: string;
  errorIcon?: ReactNode;
  filename?: string;
}
const useHandleDownload = (): ((options: IHandleDownloadOptions) => void) => {

  return async ({ filename = "file.pdf", url, errorMessage, errorIcon }: IHandleDownloadOptions) => {
    if (!url) {
      toast.error(errorMessage ?? "Ошибка при скачивании файла", {
        icon: errorIcon ?? <ErrIcon />,
      })

      return;
    }

    try {
      if (Platform.OS === "web") {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {

        await Linking.openURL(url);
      }
    } catch {
      toast.error("При скачивании произошла ошибка", {
        icon: <ErrIcon />,
      });
    }
  };
};

export default useHandleDownload;
